export default __webpack_public_path__ + "static/media/suitcase.e14b0bb3.png";